module.exports = __webpack_public_path__ + "static/media/clear-icon.5ac2f923.svg";